import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withQuery } from "components/common";
import { withRouter } from "react-router";
import { GET_ISSUING_STATE_QUERY } from "./gql";
import { ISSUING_STATUS } from "./constants";
import IssuingOnboarding from "./IssuingOnboarding";
import IssuingCardholderAgreement from "./IssuingCardholderAgreement";
import IssuingApproved from "./IssuingApproved";
import IssuingProcessing from "./IssuingProcessing";
import IssuingRejected from "./IssuingRejected";

const Issuing = ({ data: { getUserIssuingStatus = {} } = {}, queryOps }) => {
  let { status } = getUserIssuingStatus;
  const { startPolling, stopPolling } = queryOps;
  const [timedOut, setTimedOut] = useState(false);

  const handleTimedOut = () => {
    stopPolling();
    setTimedOut(true);
  };

  if (status !== ISSUING_STATUS.PROCESSING) {
    stopPolling();
  }

  const restartPolling = () => {
    status = ISSUING_STATUS.PROCESSING;
    setTimedOut(false);
    startPolling(3000);
    setTimeout(() => {
      handleTimedOut();
    }, 60000);
  };

  useEffect(() => {
    setTimeout(() => {
      handleTimedOut();
    }, 60000);
  },[]);

  const render = () => {
    switch (status) {
      case ISSUING_STATUS.REQUIRED_CARDHOLDER_AGREEMENT:
        return <IssuingCardholderAgreement restartPolling={restartPolling} />;
      case ISSUING_STATUS.PROCESSING:
        return <IssuingProcessing timedOut={timedOut} restartPolling={restartPolling} />;
      case ISSUING_STATUS.ELIGIBLE:
      case ISSUING_STATUS.ONBOARDING:
        return <IssuingOnboarding userIssuingStatus={getUserIssuingStatus} />;
      case ISSUING_STATUS.REJECTED:
        return <IssuingRejected status={status} />;
      case ISSUING_STATUS.APPROVED:
        return <IssuingApproved userIssuingStatus={getUserIssuingStatus} />;
      default:
        // TODO: this shouldn't happen. show error and send back to home
        return "Unknown status";
    }
  };

  return render();
};

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default compose(
  connect(mapStateToProps),
  withQuery(GET_ISSUING_STATE_QUERY, { pollInterval: 3000 }),
  withRouter,
)(Issuing);
